import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const InstantPickingSummaryCard = ({ data = [], onClick = () => {} }) => {
  let xsLabel = 2.2;
  let xsColon = 0.1;
  let xsValue = 3.7;

  let mdLabel = 3;
  let mdColon = 0.5;
  let mdValue = 8.5;
  return (
     
    // <Grid container spacing={1}>
    //   {data.map((obj, index) => (
    //     <Grid
    //       item
    //       xs={12}
    //       sm={12}
    //       md={6}
    //       key={index}
    //       onClick={() => {
    //         let items = { row: obj };
    //         onClick(items);
    //       }}
    //     >
    //       <Grid
    //         container
    //         spacing={0}
    //         rowSpacing={0}
    //         sx={{ 
    //           borderWidth: "1px 1px 1px 5px",
    //           borderStyle: "solid solid solid solid",
    //           borderRadius: "0px 10px 10px 0px",
    //           padding: "12px 8px",
    //           marginTop: "5px",
    //           borderColor: "#0d73bb",
 
    //         }}
    //         columns={{ xs: 6, sm: 12, md: 24 }}
    //         className="PickingHeadCard"
    //       >
    //         <Grid item xs={xsLabel} md={mdLabel}>
    //           <CmpTypographyField xcomponent={"span"} xText={"Doc.No"} />
    //         </Grid>
    //         <Grid item xs={xsColon} md={mdColon}>
    //           <CmpTypographyField xcomponent={"span"} xText={" : "} />
    //         </Grid>
    //         <Grid item xs={xsValue} md={mdValue}>
    //           <CmpTypographyField xcomponent={"span"} xText={obj.VocNo} />
    //         </Grid>

   
 
    //         <Grid item xs={xsLabel} md={mdLabel}>
    //           <CmpTypographyField xcomponent={"span"} xText={"Date"} />
    //         </Grid>
    //         <Grid item xs={xsColon} md={mdColon}>
    //           <CmpTypographyField xcomponent={"span"} xText={" : "} />
    //         </Grid>
    //         <Grid item xs={xsValue} md={mdValue}>
    //           <CmpTypographyField
    //             xcomponent={"span"}
    //             xText={moment(obj.PostDate).format("MM/DD/YYYY")}
    //           />
    //         </Grid>

    //         <Grid item xs={xsLabel} md={mdLabel}>
    //           <CmpTypographyField xcomponent={"span"} xText={"Status"} />
    //         </Grid>
    //         <Grid item xs={xsColon} md={mdColon}>
    //           <CmpTypographyField xcomponent={"span"} xText={" : "} />
    //         </Grid>
    //         <Grid item xs={xsValue} md={mdValue}>
    //           <CmpTypographyField xcomponent={"span"} xText={obj?.Status} />
    //         </Grid>

    //         <Grid item xs={xsLabel} md={mdLabel}>
    //           <CmpTypographyField xcomponent={"span"} xText={"Name"} />
    //         </Grid>
    //         <Grid item xs={xsColon} md={mdColon}>
    //           <CmpTypographyField xcomponent={"span"} xText={" : "} />
    //         </Grid>
    //         <Grid item xs={xsValue} md={mdValue}>
    //           <CmpTypographyField xcomponent={"span"} xText={obj?.PartyName} />
    //         </Grid>
            
    //       </Grid>
    //     </Grid>
    //   ))}
    // </Grid>
    <Grid container spacing={1} className="easy-putaway-container mt-1">
    {data.map((item, index) => (
      <Grid item xs={12} sm={6} md={6} key={index} onClick={() => {
                let items = { row: item };
                onClick(items);
              }}>
        <div className="easy-putaway-card">
          <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle1" className="label">
              Doc.No
              </Typography>
            </Grid>
            <Grid item xs={6} md={9}>
              <Typography variant="body1" className="value">
                {item.VocNo}
              </Typography>
            </Grid>
             
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle1" className="label">
              Date
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="body1" className="value">
                {moment(item.PostDate).format('MM/DD/YYYY')}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle1" className="label">
              Status
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="body1" className="value">
                {item.Status}
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="subtitle1" className="label">
               Name
              </Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="body1" className="value">
                {item.PartyName}
              </Typography>
            </Grid>
            
          </Grid>
        </div>
      </Grid>
    ))}
  </Grid>
  );
};
